<template>
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.5 4.5V10M5.5 4.5L4.85849 3.5L5.01887 2H6.01887L6.14151 3.5L5.5 4.5ZM5.5 10V10C6.05228 10 6.5 10.4477 6.5 11V16.3377C6.5 16.4452 6.51733 16.552 6.55132 16.654L6.94868 17.846C6.98267 17.948 7 18.0548 7 18.1623V18.7639C7 18.9192 6.96385 19.0723 6.89443 19.2111L6.77639 19.4472C6.607 19.786 6.26074 20 5.88197 20H5.11803C4.73926 20 4.393 19.786 4.22361 19.4472L4.10557 19.2111C4.03615 19.0723 4 18.9192 4 18.7639V18.1623C4 18.0548 4.01733 17.948 4.05132 17.846L4.44868 16.654C4.48267 16.552 4.5 16.4452 4.5 16.3377V11C4.5 10.4477 4.94772 10 5.5 10V10Z" stroke="currentColor" stroke-linejoin="round"/>
        <path d="M14.5 5.5H10.5L13.5 2H19.5V5.5H16.5M14.5 5.5H16.5M14.5 5.5V11.5L14 13.5V20H15.5H17V13.5L16.5 11.5V5.5" stroke="currentColor" stroke-linejoin="round"/>
        <path d="M8 10.5H13M8 14.5H12.5M18 10.5H21.5V14.5H18.5M3 10.5H0.5V14.5H3" stroke="currentColor" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGDecoration',
};
</script>

<style scoped lang="scss">

</style>
